module.exports = __webpack_public_path__ + "static/media/teaching.bcfd1a2e.png";